import Vue from 'vue';
import Vuex from 'vuex';

import admins from './admins';
import users from './users';
import assigned_users from './assigned_users';
import contact_history from './contact_history';

Vue.use(Vuex);

export const store =  new Vuex.Store({
    modules: {
        admins,
        users,
        assigned_users,
        contact_history
    },

	state: {
		initialLoad:false
	},

	getters: {
		hasCompletedInitialLoad (state) {
			return state.initialLoad;
		}
	},

	mutations: {
		initialLoad(state) {
			state.initialLoad = true;
		}
	}
});
